import React, { useLayoutEffect, useRef, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import posthog from 'posthog-js';

// Kopia sekcji opinii ze sklepów — 1:1, teksty słowo w słowo (literówki zostają, to dowód autentyczności).
// Stan na 08.10.2026: App Store = strona apps.apple.com (serialized-server-data),
// Google Play = batchexecute rpc UsvDTd. Aktualizować ręcznie.

const APP_STORE = {
  summary: { avg: '5,0', count: 43 },
  url: 'https://apps.apple.com/pl/app/matematly-matura-z-matematyki/id6754283687?see-all=reviews',
  reviews: [
    {
      title: 'Super aplikacja',
      date: '5.03.2026',
      author: 'flyestmf',
      text: 'Bardzo polecam aplikację każdemu kto przygotowuje się do matury. Przed nauką z matematly arkusze robiłem na 40%, dwa tygodnie nauki w matematly sprawiły że mój wynik urósł do 60%. Super aplikacja, zadania są super wytłumaczone i dużo można się nauczyć. System pewniaków i utrwalania ich co parę dni sprawia że można łatwo zapamiętać schematy zadań. Super aplikacja dodałbym zadania otwarte, polecam każdemu',
      reply: {
        date: '10.03.2026',
        text: 'dzięki! taki postęp to dla nas najważniejsza nagroda, super że apka pomogła Ci poprawić wyniki z arkuszy!\nco do zadań otwartych pomyślimy jak to lepiej zrobić, obecnie zadania otwarte w appce są (te za więcej punktów), ale też mają warianty odpowiedzi żeby można było wygodnie sprawdzić swoje rozwiązanie\npowodzenia w maju!',
      },
    },
    {
      title: 'Polecam!!!',
      date: '9.07.2026',
      author: 'olisiaks123',
      text: 'Po maturze śmiało mogę stwierdzić, że Matematly była jedną z najlepszych aplikacji, z jakich korzystałam podczas przygotowań. Dzięki przejrzystym wyjaśnieniom i dobrze dobranym zadaniom udało mi się uporządkować wiedzę i nabrać pewności przed egzaminem. Aplikacja naprawdę pomaga zrozumieć matematykę, a nie tylko nauczyć się schematów. Jestem bardzo zadowolona z efektów i zdecydowanie polecam Matematly każdemu, kto przygotowuje się do matury z matematyki!',
      reply: {
        date: '14.07.2026',
        text: 'Super, mega się cieszymy, że appka pomogła Ci przygotować się do matury i zrozumieć matmę!',
      },
    },
    {
      title: 'Pierwsza aplikacja do której wykupiłam dostęp!',
      date: '21.03.2026',
      author: 'Vlrc1',
      text: 'W ogóle nie umiem matmy ale ta apka pomaga bo wyglada wszystko w formacie testu, plus AI u którego można odrazu zapytać co nie rozumiesz. Wcześniej nawet nie patrzyłam w stronę logarytmów i potęg, ale teraz robię to bez problemu, i to wynik za 5 dni korzystania z apki. Dzięki 🤍',
    },
    {
      title: 'polecam',
      date: '17.03.2026',
      author: 'karamoni',
      text: 'Świetna aplikacja ,zadania można rozwiązać w każdej chwili dzięki funkcji notesu, łatwy dostęp do karty wzorów, zadania bazowane na pewniakach cke, system powtórek aby nie zapomnieć opanowanych pewniaków, wytłumaczone zadania krok po kroku jak rozwiązać, wszystkie zagadnienia maturalne pewniaki, możliwość skorzystania z opcji ai ktora odpowiada na pytania. Warto przedłużyć dostęp,łatwa i przyjemna nauka.',
    },
    {
      title: 'Jedna z lepszych aplikacji',
      date: '6.05.2026',
      author: 'wieehdkdksd',
      text: 'Każdy kto przygotowuje się do matury powinien ją pobrać stronka ci wszystko wytłumaczy i poda ci podobne zadania meggaaa polecammm',
      reply: {
        date: '8.05.2026',
        text: 'dzięki, mamy nadzieję że matura poszła dobrze!',
      },
    },
  ],
};

const GOOGLE_PLAY = {
  summary: { avg: '4,8', count: 52 },
  url: 'https://play.google.com/store/apps/details?id=matematly.pl&hl=pl',
  // Pawejk (4★) celowo — widoczna niedoskonałość. Blueflame widać tylko w wersji EN sklepu (hl=en).
  reviews: [
    {
      author: 'Patrycja',
      avatarColor: '#7B1FA2',
      stars: 5,
      date: '9 marca 2026',
      text: 'mega polecam! apka dobrze przygotowana, zadania i pewniaki maturalne na czasie, wszystko wytłumaczone w razie problemów z rozwiązaniem. Z 30 % z arkuszy po krótkim czasie systematycznej pracy z apka robie od 60-72%, gdzie są to dla mnie wyniki, o których mogłam wcześniej pomarzyć',
      reply: { date: '10 marca 2026', text: 'dzięki! taki postęp to dla nas najlepsza nagroda, super że apka pomogła Ci poprawic wyniki. powodzenia na maturze w maju!' },
    },
    {
      author: 'Karolina',
      avatarColor: '#C2185B',
      stars: 5,
      date: '9 kwietnia 2026',
      text: 'najlepsza aplikacja do nauki matematyki do matury nauczyłam się więcej w 3 dni z tą aplikacją niż 5 lat w technikum',
      reply: { date: '17 kwietnia 2026', text: 'super, mamy nadzieję, że zdasz maturę w maju bez stresu!' },
    },
    {
      author: 'Marek',
      avatarColor: '#2E7D32',
      stars: 5,
      date: '2 października 2026',
      text: 'mega',
      reply: { date: '7 października 2026', text: 'dzięki!' },
    },
    {
      author: 'Pawejk',
      avatarColor: '#5D4037',
      stars: 4,
      date: '31 marca 2026',
      text: 'Świetna aplikacja a cena zachęca bardziej niż kursy innych osób. Brakuje paru opcji które ułatwiło by naukę, ale i tak jest dobrze.',
      reply: { date: '1 kwietnia 2026', text: 'dzięki wielkie! Daj znać czego Ci brakuje i co jeszcze byłoby przydatne - Twoja opinia jest dla nas mega ważna, jak masz jakieś pomysły jak ulepszyć appke to śmiało pisz tutaj, przez apke lub kontakt@matematly.pl - chcemy żeby matematly było jak najbardziej pomocne w nauce do matury!' },
    },
    {
      author: 'Damian',
      avatarColor: '#1565C0',
      stars: 5,
      date: '16 lipca 2026',
      text: 'To jest naprawdę dobre . Aplikacja dostosowuje poziom zadań do zaawansowania ucznia. Brawa dla Twórców. Polecam serdecznie',
      reply: { date: '17 lipca 2026', text: 'dzięki, powodzenia z zadaniami!' },
    },
    {
      author: 'Blueflame',
      avatarColor: '#0277BD',
      stars: 5,
      date: '28 września 2026',
      text: 'Bardzo fajna i klarowna aplikacja. Jest dobrze skonstruowana, myślę że jej największym plusem jest to że są wyłącznie zadania maturalne, które w razie niepewności mają opcję wyjaśnienia odpowiedzi. Jest trzy dniowy okres próbny, po czym trzeba kupić dostęp do wszystkich materiałów. Mimo to myślę że jest to warty zakup, polecam na początku września kupić dostęp bo takowy kończy się w dzień matury z matematyki.',
      reply: { date: '7 października 2026', text: 'dzięki za opinię! zdecydowanie, im szybciej zacznie się naukę do matury z matmy, tym lepiej!' },
    },
  ],
};

// Natywnie tylko własny sklep (Apple odrzuca wzmianki o Androidzie). Na webie wg urządzenia.
const getStore = () => {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios') return 'appstore';
  if (platform === 'android') return 'googleplay';
  const forced = new URLSearchParams(window.location.search).get('store');
  if (forced === 'appstore' || forced === 'googleplay') return forced;
  return /iPhone|iPad|Macintosh/.test(navigator.userAgent) ? 'appstore' : 'googleplay';
};

const openStore = (store, url) => {
  posthog.capture('checkout_store_reviews_opened', { store });
  window.open(url, Capacitor.isNativePlatform() ? '_system' : '_blank');
};

const StarPath = 'M12 17.27 18.18 21l-1.64-7.03L22 8.24l-7.19-.61L12 1 9.19 7.63 2 8.24l5.46 4.73L5.82 21z';

const Stars = ({ count = 5, size, color, gap = 1 }) => (
  <span className="inline-flex" style={{ gap }} aria-label={`${count} na 5`}>
    {[0, 1, 2, 3, 4].map(i => (
      <svg key={i} viewBox="0 0 24 24" width={size} height={size} fill={i < count ? color : 'none'} stroke={color} strokeWidth={i < count ? 0 : 2}>
        <path d={StarPath} />
      </svg>
    ))}
  </span>
);

// Raz na wejście: czy ktoś w ogóle przesuwa opinie dalej niż pierwsza karta.
const Carousel = ({ store, children }) => {
  const swipedRef = useRef(false);
  const handleScroll = (e) => {
    if (swipedRef.current || e.currentTarget.scrollLeft < 40) return;
    swipedRef.current = true;
    posthog.capture('checkout_reviews_swiped', { store });
  };
  return (
    <div
      onScroll={handleScroll}
      className="-mx-4 mt-1 px-4 py-2 flex gap-2.5 overflow-x-auto snap-x snap-mandatory scroll-px-4 items-stretch [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      {children}
    </div>
  );
};

// Stały ubytek szerokości zamiast %: na każdym ekranie wystaje ~45 px kolejnej opinii (sygnał „przesuń”).
// Tablet: dwie karty obok siebie + kawałek trzeciej.
const CARD_SIZE = 'snap-start flex-none w-[calc(100%-40px)] sm:w-[calc(50%-28px)] self-start';
const END_TILE = 'snap-start flex-none w-[44%] sm:w-[28%] self-stretch flex flex-col items-center justify-center gap-2 px-3 py-4 text-center';

// „5,0 na 5 · średnia z 43 ocen w App Store” — liczba ocen celowo widoczna (wiarygodność).
const SummaryLine = ({ summary, store, className, strongClassName }) => (
  <p className={className}>
    <span className={strongClassName}>{summary.avg} na 5</span> · średnia z {summary.count} ocen w {store}
  </p>
);

const isClamped = (el) => !!el && el.scrollHeight > el.clientHeight + 1;

const LINE_PX = 20;
// Wszystkie zwinięte karty mają identyczną wysokość: korpus = 5 linii (nierówne karty wyglądały jak błąd).
const BODY_LINES = 5;

// Krótka opinia oddaje wolne linie korpusu odpowiedzi dewelopera (ile się zmieści);
// „więcej” tylko gdy coś jest naprawdę ucięte.
// replyOverheadPx = odstęp + nagłówek odpowiedzi (+ padding ramki na Androidzie).
const useReviewCard = (review, replyOverheadPx) => {
  const [expanded, setExpanded] = useState(false);
  const [textClamped, setTextClamped] = useState(true);
  const [replyLines, setReplyLines] = useState(0);
  const [replyClamped, setReplyClamped] = useState(false);
  const textRef = useRef(null);
  const replyRef = useRef(null);
  const hasReply = !!review.reply;

  // 1) Tekst opinii: czy ucięty i ile linii zostaje na odpowiedź. Tylko na starcie i przy resize.
  useLayoutEffect(() => {
    if (expanded) return undefined;
    const measure = () => {
      const text = textRef.current;
      if (!text) return;
      const clamped = isClamped(text);
      const freePx = BODY_LINES * LINE_PX - text.offsetHeight - replyOverheadPx;
      setTextClamped(clamped);
      setReplyLines(hasReply && !clamped ? Math.max(0, Math.floor(freePx / LINE_PX)) : 0);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [expanded, hasReply, replyOverheadPx]);

  // 2) Odpowiedź: czy jej przycięcie coś ukryło — dopiero gdy jest wyrenderowana.
  useLayoutEffect(() => {
    if (expanded) return;
    setReplyClamped(replyLines > 0 && isClamped(replyRef.current));
  }, [expanded, replyLines]);

  const showReply = hasReply && (expanded || replyLines > 0);
  const showMore = !expanded && (textClamped || replyClamped || (hasReply && !showReply));
  const bodyStyle = expanded ? undefined : { height: BODY_LINES * LINE_PX, overflow: 'hidden' };
  const replyStyle = expanded
    ? undefined
    : { display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: replyLines, overflow: 'hidden' };
  return { expanded, expand: () => setExpanded(true), textRef, replyRef, showReply, showMore, bodyStyle, replyStyle };
};

// ---------- App Store (iOS) ----------

const AppStoreCard = ({ review }) => {
  // mt-4 (16) + nagłówek 20 + mt-1 (4)
  const { expanded, expand, textRef, replyRef, showReply, showMore, bodyStyle, replyStyle } = useReviewCard(review, 40);
  return (
    <div className={`${CARD_SIZE} rounded-[12px] bg-white shadow-[0_1px_2px_rgba(0,0,0,0.06),0_4px_14px_rgba(0,0,0,0.08)] px-4 pt-3 pb-2.5 flex flex-col`}>
      <div className="flex items-baseline justify-between gap-3">
        <p className={`text-[15px] font-semibold text-black leading-5 ${expanded ? '' : 'truncate'}`}>{review.title}</p>
        <span className="flex-none text-[15px] text-[#8A8A8E] leading-5">{review.date}</span>
      </div>
      <div className="mt-1 flex items-center justify-between gap-3">
        <Stars size={12} color="#FF9500" gap={1} />
        <span className="truncate text-[15px] text-[#8A8A8E] leading-5">{review.author}</span>
      </div>
      <div className="mt-1.5" style={bodyStyle}>
        <p ref={textRef} className={`text-[15px] leading-5 text-black ${expanded ? '' : 'line-clamp-5'}`}>{review.text}</p>
        {showReply && (
          <div className="mt-4">
            <div className="flex items-baseline justify-between gap-3">
              <p className="text-[15px] font-semibold text-black leading-5">Odpowiedź dewelopera</p>
              <span className="flex-none text-[15px] text-[#8A8A8E] leading-5">{review.reply.date}</span>
            </div>
            <p ref={replyRef} className="mt-1 text-[15px] leading-5 text-black whitespace-pre-line" style={replyStyle}>{review.reply.text}</p>
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={expand}
        aria-hidden={!showMore}
        tabIndex={showMore ? 0 : -1}
        className={`self-end pt-1 text-[15px] leading-5 text-[#007AFF] ${showMore ? '' : 'invisible'} ${expanded ? 'hidden' : ''}`}
      >
        więcej
      </button>
    </div>
  );
};

const AppStoreReviews = () => {
  return (
    <section className="w-full bg-white">
      <SummaryLine
        summary={APP_STORE.summary}
        store="App Store"
        className="text-sm text-[#8A8A8E]"
        strongClassName="font-semibold text-[#3C3C43]/85"
      />
      <Carousel store="appstore">
        {APP_STORE.reviews.map(r => <AppStoreCard key={r.author} review={r} />)}
        <button
          type="button"
          onClick={() => openStore('appstore', APP_STORE.url)}
          className={`${END_TILE} rounded-[12px] bg-white shadow-[0_1px_2px_rgba(0,0,0,0.06),0_4px_14px_rgba(0,0,0,0.08)]`}
        >
          <svg viewBox="0 0 24 24" width="24" height="24" fill="#007AFF" aria-hidden="true"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" /></svg>
          <span className="text-[15px] font-medium leading-5 text-[#007AFF]">Wybrane opinie · zobacz wszystkie w App Store</span>
        </button>
      </Carousel>
    </section>
  );
};

// ---------- Google Play (Android) ----------

const GooglePlayCard = ({ review }) => {
  // mt-2 (8) + padding ramki 2×8 + nagłówek 20 + mt-1 (4)
  const { expanded, expand, textRef, replyRef, showReply, showMore, bodyStyle, replyStyle } = useReviewCard(review, 48);
  return (
    <div className={`${CARD_SIZE} rounded-2xl bg-white shadow-[0_1px_2px_rgba(0,0,0,0.06),0_4px_14px_rgba(0,0,0,0.08)] px-4 pt-3.5 pb-2.5 flex flex-col`}>
      <div className="flex items-center gap-3">
        <span className="flex-none w-8 h-8 rounded-full grid place-items-center text-sm font-medium text-white" style={{ backgroundColor: review.avatarColor }}>
          {review.author[0]}
        </span>
        <span className="truncate text-sm text-[#1F1F1F]">{review.author}</span>
      </div>
      <div className="mt-3 flex items-center gap-2">
        <Stars count={review.stars} size={12} color="#01875F" gap={0} />
        <span className="text-xs text-[#444746]">{review.date}</span>
      </div>
      <div className="mt-2" style={bodyStyle}>
        <p ref={textRef} className={`text-sm leading-5 text-[#444746] ${expanded ? '' : 'line-clamp-5'}`}>{review.text}</p>
        {showReply && (
          <div className="mt-2 rounded-lg bg-[#F1F3F4] px-3 py-2">
            <div className="flex items-baseline justify-between gap-3">
              <span className="text-sm leading-5 text-[#1F1F1F]">Matematly</span>
              <span className="flex-none text-xs text-[#444746]">{review.reply.date}</span>
            </div>
            <p ref={replyRef} className="mt-1 text-sm leading-5 text-[#444746]" style={replyStyle}>{review.reply.text}</p>
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={expand}
        aria-hidden={!showMore}
        tabIndex={showMore ? 0 : -1}
        className={`self-start pt-2 text-sm font-medium text-[#01875F] ${showMore ? '' : 'invisible'} ${expanded ? 'hidden' : ''}`}
      >
        Więcej
      </button>
    </div>
  );
};

const GooglePlayReviews = () => {
  return (
    <section className="w-full bg-white">
      <SummaryLine
        summary={GOOGLE_PLAY.summary}
        store="Google Play"
        className="text-sm text-[#444746]"
        strongClassName="font-medium text-[#1F1F1F]"
      />
      <Carousel store="googleplay">
        {GOOGLE_PLAY.reviews.map(r => <GooglePlayCard key={r.author} review={r} />)}
        <button
          type="button"
          onClick={() => openStore('googleplay', GOOGLE_PLAY.url)}
          className={`${END_TILE} rounded-2xl bg-white shadow-[0_1px_2px_rgba(0,0,0,0.06),0_4px_14px_rgba(0,0,0,0.08)]`}
        >
          <svg viewBox="0 0 24 24" width="24" height="24" fill="#01875F" aria-hidden="true"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" /></svg>
          <span className="text-sm font-medium leading-5 text-[#01875F]">Wybrane opinie · zobacz wszystkie w Google Play</span>
        </button>
      </Carousel>
    </section>
  );
};

const StoreReviews = () => (getStore() === 'appstore' ? <AppStoreReviews /> : <GooglePlayReviews />);

export default StoreReviews;
